import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Award, PartyPopper } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { tenureText } from "@/components/agreements/agreementApi";

const NEXT = [1, 2, 3, 5, 10, 15, 20, 25];

export const TenureCard = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [t, setT] = useState(undefined);
  useEffect(() => { api("/agreements/tenure").then((r) => setT(r.tenure)).catch(() => setT(null)); }, []);
  if (!t) return null;
  const next = NEXT.find((n) => n > t.years);
  const toNext = next ? next * 12 - t.total_months : null;
  if (t.celebrate) {
    return (
      <div data-testid="tenure-celebration" className="mb-6 flex items-center gap-4 rounded-xl border p-4" style={{ borderColor: "#4CCC06", background: "linear-gradient(90deg, rgba(76,204,6,0.22), rgba(76,204,6,0.04))" }}>
        <PartyPopper size={30} color="#4CCC06" className="shrink-0" />
        <div className="flex-1">
          <p className="text-[10px] font-extrabold tracking-[2px] text-[#4CCC06]">HAPPY ANNIVERSARY</p>
          <p className="text-lg font-extrabold text-white" data-testid="tenure-celebration-title">{t.anniversary_years} year{t.anniversary_years === 1 ? "" : "s"} with ALR!</p>
          <p className="text-xs text-neutral-300">Thank you for building ALR with us. Here's to your biggest year yet. Keep growing!</p>
        </div>
      </div>
    );
  }
  return (
    <button data-testid="tenure-card" onClick={() => user.role === "franchisee" && navigate("/my-agreement")} className="mb-6 flex w-full items-center gap-3 rounded-xl border border-[#333] bg-[#141414] px-4 py-3 text-left transition-transform duration-150 hover:-translate-y-0.5">
      <Award size={22} color="#4CCC06" className="shrink-0" />
      <span className="flex-1">
        <span className="block text-[9px] font-extrabold tracking-[1.6px] text-[#4CCC06]">YOUR ALR JOURNEY</span>
        <span className="block text-[14px] font-extrabold text-white" data-testid="tenure-card-text">{tenureText(t)} as an ALR franchisee</span>
        {next && <span className="block text-xs text-neutral-400">{toNext} month{toNext === 1 ? "" : "s"} to your {next}-year milestone. Keep growing!</span>}
      </span>
      {user.role === "franchisee" && <span className="text-[11px] font-extrabold text-[#4CCC06]">My agreement →</span>}
    </button>
  );
};

export const AdminAgreementsWatch = () => {
  const navigate = useNavigate();
  const [d, setD] = useState(null);
  useEffect(() => { api("/agreements/admin/list").then(setD).catch(() => {}); }, []);
  if (!d) return null;
  const ok = !d.flagged;
  return (
    <button data-testid="admin-agreements-watch" onClick={() => navigate("/admin/agreements")} className="mb-6 flex w-full items-center gap-3 rounded-xl border px-4 py-3 text-left" style={{ background: "#141414", borderColor: ok ? "#333" : "#F5B700" }}>
      <Award size={20} color={ok ? "#4CCC06" : "#F5B700"} />
      <span className="flex-1">
        <span className="block text-[11px] font-extrabold tracking-[2px]" style={{ color: ok ? "#4CCC06" : "#F5B700" }}>FRANCHISE AGREEMENTS</span>
        <span className="block text-sm text-white" data-testid="admin-agreements-watch-text">{ok ? "All agreements on file and in line." : `${d.missing} missing · ${d.flagged} location${d.flagged === 1 ? "" : "s"} with flags`}</span>
      </span>
      <span className="text-[11px] font-extrabold text-[#4CCC06]">Open →</span>
    </button>
  );
};
